import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Box,
  AccordionIcon,
  Text,
  BoxProps,
  Stack,
  Center,
  useDisclosure,
} from "@chakra-ui/react";
import CloseWindow from "components/Pay/CloseWindow";

interface IProps extends BoxProps {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  closeWindow?: boolean;
}
const ExchangeInfoAccordion = ({ title, children, isOpen, closeWindow, ...props }: IProps) => {
  const { isOpen: dOpen, onToggle } = useDisclosure();
  return (
    <Box {...props}>
      <Accordion
        allowToggle
        defaultIndex={isOpen ? 0 : undefined}
        border="0px solid transparent"
        p="0"
        borderRadius="10px"
        bg="#F8F9F9"
        onClick={onToggle}
      >
        <AccordionItem px="12px">
          {({ isExpanded }) => (
            <>
              <Box
                py={{ base: "16px", "1sm": "20px" }}
                px="0"
                border={isExpanded ? "1px solid transparent" : "none"}
                borderBottomColor="#F0F1F3"
              >
                <AccordionButton p="0" _hover={{ bg: "none" }} textTransform="initial">
                  <Text
                    as="span"
                    flex="1"
                    textAlign="left"
                    fontSize={{ base: "14px", "1sm": "16px" }}
                    fontWeight="600"
                    color="primary.default"
                  >
                    {title}
                  </Text>
                  <AccordionIcon />
                </AccordionButton>
              </Box>

              <AccordionPanel p={0}>
                <Stack px="12px" py={{ base: "12px", "1sm": "20px" }} gridGap="10px" sx={{ "> *": { mt: "0 !important" } }}>
                  {children}
                </Stack>
              </AccordionPanel>
            </>
          )}
        </AccordionItem>
      </Accordion>

      {closeWindow && (
        <Center mt={{ base: dOpen ? "12px" : "100px", md: dOpen ? "12px" : "200px" }}>
          <CloseWindow />
        </Center>
      )}
    </Box>
  );
};

export default ExchangeInfoAccordion;
